
import { ProgressSteps } from "@/components/auth/ProgressSteps";
import { RegistrationForm } from "@/components/auth/RegistrationForm";
import { LoginPromptCard } from "@/components/auth/LoginPromptCard";
import { AuthGuard } from "@/components/auth/AuthGuard";

export default function Register() {
  return (
    <AuthGuard requireAuth={false}>
      <div className="min-h-screen bg-background flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl w-full">
        <ProgressSteps currentStep={1} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <RegistrationForm />
          </div>

          <div>
            <LoginPromptCard />
          </div>
        </div>
      </div>
    </div>
    </AuthGuard>
  );
}
